import { z } from "zod";

export const FyCycleOptionSchema = z.object({
  id: z.string().uuid(),
  workspaceId: z.string(),
  name: z.string(),
  isDefault: z.boolean(),
  createdAt: z.string(),
});

export type FyCycleOption = z.infer<typeof FyCycleOptionSchema>;
